<template>
    <div class="pr-8">
        <!-- <div class="text-sm">
            <div class="my-1">Klicke auf "STIMME AUFNEHMEN" um mit der Aufnahme deiner Botschaft zu starten. Die maximale Länge deiner Botschaft beträgt 10 Sekunden.</div>
        </div> -->
        <div class="mt-4">
            <SoundRecords></SoundRecords>
        </div>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import SoundRecords from "./SoundRecords.vue";

export default {
    components: {
        SoundRecords
    },
    computed: {
        ...mapFields({
            soundFiles: 'soundFiles'
        }),
    },
    methods: {

    }
}
</script>
